<p-confirmDialog #editDialog key="editDialog-{{ tableData.pageId }}-{{ tableData.id }}">
  <ng-template pTemplate="headless">
    <ct-extraction-dialog
      acceptText="Bestätigen"
      closeText="Abbrechen"
      title="Manuelle Änderung verwerfen"
      (acceptDialog)="acceptedDialog.emit(); editDialog.onAccept()"
      (closeDialog)="editDialog.onReject()">
      <p>
        Wenn Du das Layout der Tabelle veränderst gehen deine manuellen Änderungen in der Tabelle
        verloren.
      </p>
    </ct-extraction-dialog>
  </ng-template>
</p-confirmDialog>
